const IDENTITY_KEY = "forr:participant-identity:v1";

export const SEX_OPTIONS = [
  { key: "female", label: "Female" },
  { key: "male", label: "Male" },
  { key: "intersex-variation", label: "Intersex or another sex variation" },
  { key: "prefer-not", label: "Prefer not to say" },
];

export const emptyParticipantIdentity = () => ({
  preferredName: "",
  firstName: "",
  lastName: "",
  email: "",
  age: "",
  sex: "",
});

export function normalizeParticipantIdentity(identity = {}) {
  const preferredName = String(identity.preferredName || identity.firstName || "").trim();
  const firstName = String(identity.firstName || "").trim();
  const lastName = String(identity.lastName || "").trim();
  return {
    preferredName,
    firstName,
    lastName,
    fullName: [firstName, lastName].filter(Boolean).join(" "),
    email: String(identity.email || "").trim().toLowerCase(),
    age: Number(identity.age) || null,
    sex: String(identity.sex || ""),
  };
}

export function participantIdentityValid(identity = {}) {
  const normalized = normalizeParticipantIdentity(identity);
  return Boolean(
    normalized.preferredName &&
      normalized.firstName &&
      normalized.lastName &&
      /^\S+@\S+\.\S+$/.test(normalized.email) &&
      Number.isInteger(normalized.age) &&
      normalized.age >= 18 &&
      normalized.age <= 120 &&
      normalized.sex,
  );
}

export function saveParticipantIdentity(identity) {
  const normalized = normalizeParticipantIdentity(identity);
  if (!participantIdentityValid(normalized)) return null;
  try {
    localStorage.setItem(IDENTITY_KEY, JSON.stringify(normalized));
    window.dispatchEvent(new CustomEvent("adaptive-participant-identity-saved", { detail: normalized }));
  } catch (_error) {
    // The current session can continue when storage is unavailable.
  }
  return normalized;
}

export function loadParticipantIdentity() {
  try {
    const raw = localStorage.getItem(IDENTITY_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return participantIdentityValid(parsed) ? normalizeParticipantIdentity(parsed) : null;
  } catch (_error) {
    return null;
  }
}

export function clearParticipantIdentity() {
  try {
    localStorage.removeItem(IDENTITY_KEY);
  } catch (_error) {
    // Non-fatal.
  }
}

export function sexLabel(value) {
  return SEX_OPTIONS.find((option) => option.key === value)?.label || "Not specified";
}
